import { render, staticRenderFns } from "./risk.vue?vue&type=template&id=4be3e8fa"
import script from "./risk.vue?vue&type=script&lang=js"
export * from "./risk.vue?vue&type=script&lang=js"
import style0 from "./risk.vue?vue&type=style&index=0&id=4be3e8fa&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports